module.exports = __webpack_public_path__ + "img/Magnuss42.a773eae6.jpg";